import { Link } from "react-router-dom";
import { Clock, CheckCircle2, Sparkles, Loader2, Lock } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const catColor = {
  "Animaux": "var(--sage)", "Magie & Féerie": "var(--sky)", "Nature": "var(--sun)",
  "Aventure": "var(--terracotta)", "Mes créations": "var(--blush)",
};

export default function StoryCard({ story, big = false, index = 0 }) {
  const generating = story.status === "generating";
  const failed = story.status === "failed";
  return (
    <Link to={story.locked ? "/premium" : `/histoire/${story.id}`} data-testid={`story-card-${story.id}`}
      style={{ animationDelay: `${index * 70}ms` }}
      className={`rise group card-paper relative flex flex-col overflow-hidden transition-transform duration-300 hover:-translate-y-1 ${big ? "md:col-span-8 md:row-span-2" : "md:col-span-4"}`}>
      <div className={`relative overflow-hidden bg-[color:var(--paper-2)] ${big ? "aspect-[16/10] md:aspect-auto md:min-h-[360px] md:flex-1" : "aspect-[3/2]"}`}>
        {story.cover ? (
          <img src={mediaUrl(story.cover)} alt={story.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="grid h-full place-items-center text-[color:var(--muted-ink)]">
            {generating ? <Loader2 className="animate-spin" size={36} /> : <Sparkles size={36} />}
          </div>
        )}
        {story.locked && (
          <span data-testid={`story-locked-${story.id}`} className="absolute inset-0 grid place-items-center bg-[#2C221E]/45">
            <span className="flex items-center gap-2 rounded-full bg-white px-4 py-2 font-display font-bold"><Lock size={16} /> Premium</span>
          </span>
        )}
        <span className="absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white"
          style={{ background: catColor[story.category] || "var(--espresso)" }}>{story.category}</span>
        {story.is_read && (
          <span data-testid={`story-read-tag-${story.id}`} className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-xs font-bold text-[color:var(--sage)]">
            <CheckCircle2 size={14} /> Lu
          </span>
        )}
      </div>
      <div className={`flex flex-col gap-2 p-5 ${big ? "" : "flex-1"}`}>
        <h3 className={`font-display font-bold leading-tight ${big ? "text-3xl" : "text-xl"}`}>{story.title}</h3>
        <p className="line-clamp-2 text-[color:var(--muted-ink)]">
          {generating ? "L'IA écrit et dessine ton histoire…" : failed ? "La création a échoué. Réessaie !" : story.summary}
        </p>
        <div className="mt-auto flex items-center gap-3 pt-2 text-sm font-bold text-[color:var(--muted-ink)]">
          <span className="rounded-full bg-[color:var(--paper-2)] px-2.5 py-1">{story.age_group} ans</span>
          {story.page_count > 0 && <span className="flex items-center gap-1"><Clock size={14} /> {story.page_count} pages</span>}
          {story.is_generated && <span className="flex items-center gap-1 text-[color:var(--terracotta)]"><Sparkles size={14} /> IA</span>}
        </div>
      </div>
    </Link>
  );
}
